import Action from './modules/action';

const $body = $('body');

// Клик
$body.on('click', '[data-click]', function () {
  const data = $(this).data('click');

  new Action(data, this);
  if ($(this).is('a')) return false;
});

$('.js-redirect').on('change', (event) => {
  const $this = $(event.currentTarget);

  document.location.href = $this.val();
});
